<template>
  <div id="main" style="padding-bottom: 50px;">

    <!-- Toolbar -->
    <v-toolbar fixed app>
      <v-toolbar-side-icon @click.stop="$store.commit('app/apriDrawer')"></v-toolbar-side-icon>
      <v-img :src="require('@/assets/img/logo1.png')" contain position="left" width="100" height="40"></v-img>

      <v-spacer></v-spacer>

      <v-toolbar-title class="display-bold ml-0">{{ getLink }}</v-toolbar-title>
    </v-toolbar>

    <!-- ROUTER VIEW -->
    <router-view />

    <!-- MENU LATERALE -->
    <menu-laterale @goto="goto" @esci="logout"></menu-laterale>

    <!-- MENU INFERIORE -->
    <menu-inferiore @goto="goto"></menu-inferiore>

    <!-- MENU AZIONI -->
    <menu-azioni
      v-if="getArticoloSel && ($router.currentRoute.path.split('/')[1] == 'evasione' || $router.currentRoute.path.split('/')[1] == 'ricevimento' || $router.currentRoute.path.split('/')[1] == 'maniglie')"></menu-azioni>
  </div>
</template>

<script>
import MenuAzioni from "@/components/layout/MenuAzioni";
import MenuLaterale from "@/components/layout/MenuLaterale";
import MenuInferiore from "@/components/layout/MenuInferiore";

export default {
  components: {
    MenuAzioni,
    MenuLaterale,
    MenuInferiore
  },
  data() {
    return {};
  },

  methods: {
    async init() {

      // Menu 
      this.setStoreMenu();

      try {
        // Menu utente
        await this.$store.dispatch("user/userInfo");


      } catch (error) {
        this.$toast.warning(this.$functions.getErrorMsg(error));
      }
    },

    async logout() {
      try {
        await this.$store.dispatch("auth/logout");
      } catch (error) {
        this.$toast.warning(this.$functions.getErrorMsg(error));
      }

      window.location.reload();


    },

    goto(link, tipo) {
      this.$store.dispatch("app/goto", { link: link, tipo: tipo });
    },

    setStoreMenu() {
      this.$store.dispatch("app/impostaMenu", {
        path: this.$route.path,
        params: this.$route.params
      });
    }
  },

  mounted() {
    this.init();
  },

  computed: {
    getLink() {
      return this.$store.getters["app/getLink"].replace("/", "").toUpperCase();
    },

    getArticoloSel() {
      return !!this.$store.getters["app/getArticoloSelezionato"];
    }
  },

  watch: {
    "$route.path": function (val) {
      //console.log(val);

      this.setStoreMenu();
    }
  }
};
</script>

<style lang="stylus">
.display-bold.has-border-bottom {
  font-weight: bold;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

.display-bold {
  font-weight: bold !important;
}

table.full-width {
  width: 100%;

  th {
    border-bottom: 1px solid black;
  }
}

.element-active, .element-active * {
  font-weight: bold;
}
</style>
